import React from 'react';
import { Box } from '@mui/material';
import CIHAChartsContainer from '../Common/CIHAChartsContainer';
import ProductionTemporalWrapper from './index';

const ProductionTemporal = () => {
    return (
        <Box>
            <Box className="content">
                <CIHAChartsContainer
                    title={'Produção / Série Temporal'}
                    className="services-container-dashboards"
                >
                    <ProductionTemporalWrapper />
                </CIHAChartsContainer>
            </Box>
        </Box>
    );
};

export default ProductionTemporal;
